export default __webpack_public_path__ + "images/9c9e86005ed8f94dce2492967e1bc9cd.svg";